import React from 'react'
import { Navigate } from 'react-router-dom'
import AuthProvider from '../../providers/AuthProvider'
import Home from '../Home'
import CrossClientDashboard from './CrossClientDashboard'
import {
  buildV3CrossClientDashboardPath,
  buildV3HomePath,
  getUserDashboardV3Enabled,
} from '../../services/ClientDashboardV3'

export default function DashboardHomeEntryRoute({ mode = 'home' }) {
  const authContext = AuthProvider.useAuth()
  const currentUser = authContext?.user

  if (getUserDashboardV3Enabled(currentUser)) {
    return <Navigate to={mode === 'cross-client' ? buildV3CrossClientDashboardPath() : buildV3HomePath()} replace />
  }

  return mode === 'cross-client' ? <CrossClientDashboard /> : <Home />
}

